<ng-container *ngIf="model.serviceName">

  <div class="page-header" id="app-service-details">
    <div class="container">
      <lib-breadcrumb *ngIf="serviceLoaded" [breadcrumbs]="_service.config.breadcrumbs"
        [currentPage]="breadCrumbServiceName" [parentPath]="serviceListRouteName"></lib-breadcrumb>
      <div class="d-flex gap-4 align-items-center pt-3">
        <div class="service-img" *ngIf="!isMobile">
          <a  [title]="model.serviceName"
            href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + model.id : serviceDetailsRoute + '/' +  model.id }}"
            class="text-decoration-none">
            <img loading="lazy" *ngIf="!model.image" src="../../assets/images/service-catalog.svg"
              class="object-fit-contain" [alt]=" model.serviceName" />
            <img loading="lazy" *ngIf="model.image" [src]="getImageSrc(model.image)" class="object-fit-contain"
              [alt]=" model.serviceName" /></a>
        </div>
        <h1 class="page-title p-0">
          {{ model.serviceName }}
        </h1>
      </div>
    </div>
  </div>
  <!-- 
  <div class="top-mobile-ribbon">
    <div class="container">
      <div class="ribbon-wrp">
        <div class="navigation-wrp">
          <a [href]="serviceCardsRoute" class="back-link">
            <span class="lib-icon-left-arrow"></span>
          </a>
        </div>
        <button *ngIf="!model.isExternal" type="button" (click)="onApplyClick()" class="action-btn"
          title="{{getApplyButtonTooltip()}}">
          {{ translationData?.applyForRequest || "Apply for request" }}
          <span id="applyTooltip" popover="{{getApplyButtonTooltip()}}" placement="bottom" triggers="click"
            [outsideClick]="true">
          </span>
        </button>
        <a target="_blank" *ngIf="model.isExternal" [class.disabled]="!model?.isEligibleToApply"
          title="{{ translationData?.externalServiceNote ||'This is an external service, and you will leave the site to apply for the request'}}"
          [href]="model.externalServiceUrl" class="action-btn d-lg-block external-link p-0">
          {{ translationData?.applyForRequest || "Apply For Request" }}
          <span class="lib-icon-left-arrow"></span>
        </a>
      </div>
    </div>
  </div> -->


  <div class="container service-details-content">
    <div class="d-flex gap-4 align-items-center py-4 d-none d-xs-flex">
      <div class="service-img">
        <a  [title]="model.serviceName"
          href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + model.id : serviceDetailsRoute + '/' +  model.id }}"
          class="text-decoration-none">
          <img loading="lazy" *ngIf="!model.image" src="../../assets/images/service-catalog.svg"
            class="object-fit-contain" [alt]=" model.serviceName" />
          <img loading="lazy" *ngIf="model.image" [src]="getImageSrc(model.image)" class="object-fit-contain"
            [alt]=" model.serviceName" /></a>
      </div>
      <h1 class="page-title d-none d-xs-flex">
        {{ model.serviceName }}
      </h1>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <aside class="service-details-card rounded">
          <header class="details-header border-bottom">
            <h2 class="title">
              {{ translationData?.serviceDetails || "Service Details" }}
            </h2>
            <div class="sharer position-relative">
              <button class="sharer-btn p-0 border-0 rounded-circle position-relative" type="button" role="button"
                [title]="translationData.share" >
                <span class="icon-share">
                </span>
              </button>
              <div class="sharer-links position-absolute">
                <ul class="list-unstyled d-flex justify-content-center align-items-center h-100">
                  <li>
                    <a href="https://www.facebook.com/sharer/sharer.php?u={{baseuRL+'/%23/services/service-details/' + model.id}}&amp;src=sdkpreparse"
                      class="d-flex align-items-center" target="_blank" [title]="translationData.facebook" >
                      <span class="icon-facebook icon-social"></span>
                    </a>
                  </li>
                  <li>
                    <a href="http://twitter.com/share?text=&url={{baseuRL+'/%23/services/service-details/' + model.id}}&hashtags"
                      class="d-flex align-items-center" target="_blank" [title]="translationData.twitter" >
                      <span class="icon-twitter icon-social"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/sharing/share-offsite/?url={{baseuRL+'/%23/services/service-details/' + model.id}}"
                      class="d-flex align-items-center" target="_blank" [title]="translationData.linkedin" >
                      <span class="icon-linkedin-2 icon-social"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/?text={{ baseuRL+'/%23/services/service-details/' + model.id}}"
                      data-action="share/whatsapp/share" class="d-flex align-items-center" target="_blank"
                      [title]="translationData.whatsapp" >
                      <span class="icon-whatsapp icon-social"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </header>
          <div class="details-body row">
            <div class="col-md-6 col-lg-12 service-details-card-name">
              <span class="icon icon-service-name"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.serviceName || "Service Name" }}
                </div>
                <p class="content">{{ model.serviceName }}</p>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 service-details-card-name"
              *ngIf="model?.serviceDefinitionUserSegments?.length">
              <span class="icon-user-segments"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.serviceUserSegments || "User Segments" }}
                </div>
                <p>
                  <span *ngFor="let segmentId of model.serviceDefinitionUserSegments; let i = index" class="content">
                    <ng-container *ngIf="i != 0">, </ng-container>{{ getUserSegmentName(segmentId) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 service-details-card-name">
              <span class="icon-categories"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.serviceCategory || "Category" }}
                </div>
                <p>
                  <span *ngFor="let categoryId of model.serviceDefinitionCategories;let i = index" class="content">
                    <ng-container *ngIf="i != 0">, </ng-container>{{ getServiceCategoryName(categoryId) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 service-details-card-name">
              <span class="icon-channels"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.serviceChannel || "Service Channel" }}
                </div>
                <p>
                  <span *ngFor="let channelId of model.serviceDefinitionChannels; let i = index" class="content">
                    <ng-container *ngIf="i != 0">, </ng-container>{{ getServiceChannelType(channelId) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 service-details-card-name">
              <span class="icon-register"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.requireRegistration || "Require Registration" }}
                </div>
                <p class="content">{{ model.requireRegistration ? translationData?.required :
                  translationData?.notRequired}}</p>
              </div>
            </div>
            <div class="col-md-6 col-lg-12 service-details-card-name">
              <span class="icon-multiple-require"></span>
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.multipleRequests || "Multiple Requests" }}
                </div>
                <p class="content">{{ model.enableMultipleRequests ? translationData?.allowed :
                  translationData?.NotAllowed }}</p>
              </div>
            </div>
            <div *ngIf="model.isExternal || isStatic || isAutomated"
              class="col-md-6 col-lg-12 service-details-card-name">
              <div class="service-details-card-title">
                <div class="label">
                  {{ translationData?.serviceType || "Service Type" }}
                </div>
                <p class="content">{{ model.isExternal ? (translationData?.external || "External") :
                  isStatic ? (translationData?.static || "Static") : (translationData?.automated || "Automated") }}</p>
              </div>
            </div>
          </div>
          <div class="bottom-section-wrp" [ngClass]="{'justify-content-end' : !hasInquiryAppointment}">
            <div *ngIf="hasInquiryAppointment" class="info">
              <span class="lib-icon-question-2"></span>
              <div class="text">
                <div>{{translationData?.needHelpInProcedure || "Need help in procedures?"}}
                </div>
                <a  [title]="translationData?.bookAppointment" href=""
                  class="link-btn">{{translationData?.bookAppointment || "Book Appointment"}}</a>
              </div>
            </div>
            <button *ngIf="!model.isExternal && !isStatic && !isAutomated" type="button"
              [disabled]="!model?.isEligibleToApply" (click)="onApplyClick()" class="btn btn-primary primary-btn"
              aria-label="Apply for request" title="{{getApplyButtonTooltip()}}">
              {{ translationData?.applyForRequest || "Apply for request" }}
            </button>
            <a aria-label="apply For Request" target="_blank" *ngIf="model.isExternal && !isStatic && !isAutomated"
              [class.disabled]="!model?.isEligibleToApply"
              title="{{ translationData?.externalServiceNote ||'This is an external service, and you will leave the site to apply for the request'}}"
              [href]="model.externalServiceUrl" class="btn btn-primary primary-btn  external-link">
              {{ translationData?.applyForRequest || "Apply For Request" }}
              <span class="lib-icon-left-arrow"></span>
            </a>
          </div>
        </aside>
      </div>
      <div class="col-lg-9">
        <div class=" tabs-rating-cont">
          <section class="main-block block-wrapper rounded">
            <div class="row">
              <div class="col-lg-12">
                <div class="profile-form rounded d-none d-lg-block">
                  <!-- submission form tabs -->
                  <div class="scrolling-tabs withoutNav">
                    <div [swiper]="swiperConfig" class="swiper-container" [dir]="dir">
                      <ul class="swiper-wrapper nav nav-tabs {{ swiperClass }}" role="tablist"
                        [ngClass]="{'overflow-hidden justify-content-center' : isMobile}">
                        <li class="nav-item swiper-slide" [ngClass]="isBlanK?'':'active'" attr.data-index="0">
                          <a  [title]="translationData?.serviceDescription" class="nav-link "
                            [ngClass]="isBlanK?'':'active'" id="tab0-btn" data-toggle="tab" href="#tab0" role="tab"
                            aria-controls="tab" aria-selected="true">
                            <span>
                              {{ translationData?.serviceDescription || "Description" }}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="1"
                          *ngIf="model?.prerequisites || prerequisitesAttachmentsData?.length">
                          <a class="nav-link " [title]="translationData?.servicePrerequisite" id="tab1-btn"
                            data-toggle="tab" href="#tab1" role="tab" aria-controls="tab" aria-selected="true">
                            <span>
                              {{translationData?.servicePrerequisites || "Prerequisites"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="2"
                          *ngIf="model?.requiredDocuments || requiredDocumentsAttachmentsData?.length || model?.requiredDocumentsListFormConfig?.length">
                          <a class="nav-link"  [title]="translationData?.serviceRequiredDocuments" id="tab2-btn"
                            data-toggle="tab" href="#tab2" role="tab" aria-controls="tab" aria-selected="true">
                            <span>
                              {{translationData?.serviceRequiredDocuments ||"Required Documents"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="3"
                          *ngIf="model?.sla || (model?.readConfigSLA && model?.totalStepsSLA)">
                          <a class="nav-link"  [title]="translationData?.serviceSLA " id="tab3-btn" data-toggle="tab" href="#tab3"
                            role="tab" aria-controls="tab" aria-selected="true">
                            <span>
                              {{ translationData?.serviceSLA || "SLA" }}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="4"
                          *ngIf="model?.policiesProcedures || policiesAttachmentsData?.length">
                          <a class="nav-link"  [title]="translationData?.servicePolicesAndProcedures"
                            id="tab4-btn" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab"
                            aria-selected="true">
                            <span>
                              {{ translationData?.servicePolicesAndProcedures || "Policies & Procedures"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="5" *ngIf="hasCustomAvaibailitySection()">
                          <a class="nav-link"  [title]="translationData?.serviceAvailability"
                            id="tab5-btn" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab"
                            aria-selected="true">
                            <span>
                              {{translationData?.serviceAvailability || "Service Availablility"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="6"
                          *ngIf="(model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)) || model?.fees|| feesAttachmentsData?.length">
                          <a class="nav-link"  [title]="translationData?.serviceFees" id="tab6-btn" data-toggle="tab"
                            href="#tab6" role="tab" aria-controls="tab" aria-selected="true">
                            <span>
                              {{translationData?.serviceFees || "Fees"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="7" *ngIf="templatesAttachmentsData?.length">
                          <a class="nav-link"  [title]="translationData?.templates" id="tab7-btn" data-toggle="tab"
                            href="#tab7" role="tab" aria-controls="tab" aria-selected="true">
                            <span>
                              {{translationData?.templates || "Templates"}}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item swiper-slide " attr.data-index="8" [ngClass]="isBlanK?'active':''">
                          <a class="nav-link" [ngClass]="isBlanK?'active':''" id="tab8-btn" data-toggle="tab"
                            href="#tab8" role="tab"  [title]="translationData?.TermsConditions"
                            aria-controls="tab" aria-selected="true">
                            <span>
                              {{translationData?.TermsConditions || "Terms & Conditions"}}
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="swiper-button-prev d-none d-lg-block"></div>
                      <div class="swiper-button-next d-none d-lg-block"></div>
                    </div>
                  </div>

                  <!-- submission form tabs content -->
                  <div #tabscontent class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade allow-to-Print" [ngClass]="isBlanK?'':'active show'" id="tab0"
                      role="tabpanel" aria-labelledby="pills-tab">
                      <p class="block-brief">
                      </p>
                      <app-text-editor [isReadOnly]="true" [(ngModel)]="model.description"></app-text-editor>
                      <ul class="m-0 uploaded-files-wrapper"
                        *ngIf="descriptionAttachmentsData && descriptionAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of descriptionAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab1" role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor [isReadOnly]="true" [(ngModel)]="model.prerequisites"></app-text-editor>

                      <ul class="m-0 uploaded-files-wrapper" *ngIf="prerequisitesAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of prerequisitesAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab2" role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor [isReadOnly]="true"
                        *ngIf="!model?.requiredDocumentsListFormConfig?.length && model?.requiredDocuments"
                        [(ngModel)]="model.requiredDocuments"></app-text-editor>

                      <ul *ngIf="model?.requiredDocumentsListFormConfig?.length">
                        <li *ngFor="let config of model?.requiredDocumentsListFormConfig">
                          {{config}}
                        </li>
                      </ul>

                      <ul class="m-0 uploaded-files-wrapper"
                        *ngIf="requiredDocumentsAttachmentsData && requiredDocumentsAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of requiredDocumentsAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab3" role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor *ngIf="!model?.readConfigSLA && model?.sla" [isReadOnly]="true"
                        [(ngModel)]="model.sla"></app-text-editor>

                      <!-- <p class="block-value">3-10 Working Days</p> -->

                      <div *ngIf="model?.readConfigSLA && model?.totalStepsSLA" class="block-content rich-text">
                        {{ translationData?.initialApproval || "Initial Approval" }}
                        <p class="block-value">{{model?.totalStepsSLA +' '+ (translationData?.workingHours || "Working
                          Hours")}}</p>
                      </div>

                      <!-- <app-alert-message [hasClose]="false" alertType="message" [active]="true"
                        alertText="{{translationData?.SLANote ||'SLA is depending on the list activities and fulfilling the requirements and this can be subject to change.'}}">
                      </app-alert-message> -->
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab4" role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor [isReadOnly]="true" [(ngModel)]="model.policiesProcedures"></app-text-editor>

                      <ul class="m-0 uploaded-files-wrapper"
                        *ngIf="policiesAttachmentsData && policiesAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of policiesAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>

                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab5" role="tabpanel" aria-labelledby="pills-tab">
                      <ng-container *ngIf="model?.hasCustomApplicantSubmissionFrequency">
                        <div class="font-weight-bold">
                          {{translationData?.applicantRequestingLimit || "Applicant Requesting Limit"}}
                        </div>
                        <div class="mb-2" innerHTML="{{
                          translationData?.applicantRequestingLimitMessage
                            ?.replace('{0}', model.maxRequestsPerApplicant)
                            ?.replace('{1}', model.applicantMaxRequestsDurationInDays)
                          }}">
                        </div>
                      </ng-container>
                      <ng-container *ngIf="model?.hasCustomDaysAvailability">
                        <ng-container *ngIf="model.availabilityStartDate || model.availabilityEndDate">
                          <div class="font-weight-bold">
                            {{translationData?.dateRange || "Date Range"}}
                          </div>
                          <div class="mb-2" innerHTML="{{
                            translationData?.serviceAvailabilityDateRange
                              ?.replace('{0}', (!model.availabilityStartDate ? '' : translationData?.fromRange?.replace('{0}', model.availabilityStartDateCalendar)))
                              ?.replace('{1}', (!model.availabilityEndDate ? '' : translationData?.toRange?.replace('{0}', model.availabilityEndDateCalendar)))
                            }}">
                          </div>
                        </ng-container>
                        <div *ngIf="model?.serviceDefinitionAvailabilitySlots?.length"
                          class="font-weight-bold d-flex align-items-center attach-label-holder g-1">
                          <label>
                            {{translationData?.daysAvailability || "Days Availability"}}
                          </label>
                          <label class="info-icon lib-icon-info" *ngIf="configuredTimeZoneStringValue"
                            popover="{{ translationData?.timezoneAddMessage?.replace('{0}', configuredTimeZoneStringValue) || 'Please enter the working hours in GMT time zone' }}"
                            placement="bottom" triggers="click" [outsideClick]="true">
                          </label>
                        </div>
                        <div class="block-content rich-text" *ngIf="model?.serviceDefinitionAvailabilitySlots?.length">
                          <table>
                            <tbody>
                              <tr>
                                <th>{{ translationData?.day || "Day" }}</th>
                                <th>{{ translationData?.startTime || "Start Time" }}</th>
                                <th>{{ translationData?.endTime || "End Time" }}</th>
                                <th>{{ translationData?.maxRequestsPerDay || "Max Requests" }}</th>
                              </tr>
                              <tr *ngFor="let availability of model.serviceDefinitionAvailabilitySlots">
                                <td>{{ availability.dayName }}</td>
                                <td>{{ availability.startTimeDisplay }}</td>
                                <td>{{ availability.endTimeDisplay }}</td>
                                <td>{{ availability.maxRequestsPerDay }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-container>
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab6" role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor *ngIf="!model?.readConfigFees && model?.fees" [isReadOnly]="true"
                        [(ngModel)]="model.fees"></app-text-editor>

                      <div class="block-content rich-text"
                        *ngIf="model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)">
                        <table>
                          <tbody>
                            <tr>
                              <th>{{ translationData?.feeName || "Fee Name" }}</th>
                              <th>{{ translationData?.feeAmount || "Amount" }}</th>
                            </tr>
                            <tr *ngFor="let fee of model.serviceDefinitionFees">
                              <td>{{ fee.serviceDefinitionFeeLocals[0].name }}</td>
                              <td>
                                {{
                                fee.amount +
                                " " +
                                (currencyTrans[defaultCurrencyValue] || defaultCurrencyValue)
                                }}
                              </td>
                            </tr>
                            <tr class="bottom-row">
                              <td colspan="2">
                                <span>{{
                                  translationData?.serviceTotalFees ||
                                  "Total Fees:"
                                  }}
                                </span>
                                {{
                                getTotalServicFees() +
                                " " +
                                (currencyTrans[defaultCurrencyValue] || defaultCurrencyValue)
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <ul class="m-0 uploaded-files-wrapper" *ngIf="feesAttachmentsData && feesAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of feesAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-pane fade allow-to-Print" id="tab7" role="tabpanel" aria-labelledby="pills-tab">
                      <div class="block-content rich-text">
                        {{translationData?.templatesNote || "Any required attachments within the requests should follow
                        the below templates."}}
                      </div>

                      <ul class="m-0 uploaded-files-wrapper"
                        *ngIf="templatesAttachmentsData && templatesAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of templatesAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>

                    </div>
                    <div class="tab-pane fade allow-to-Print" [ngClass]="isBlanK?'active show':''" id="tab8"
                      role="tabpanel" aria-labelledby="pills-tab">
                      <app-text-editor [(ngModel)]="model.termsConditions" [isReadOnly]="true"></app-text-editor>

                      <ul class="m-0 uploaded-files-wrapper"
                        *ngIf="termsConditionsAttachmentsData && termsConditionsAttachmentsData?.length">
                        <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                          *ngFor="let doc of termsConditionsAttachmentsData">
                          <span class="lib-icon-attachement-icon"></span>
                          <span class="uploaded-file-name"
                            title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                            (click)="download(doc.attachmentGuid,doc.fileName)">
                            {{doc.fileName}}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- mobile version -->
                <div class="d-none d-xs-flex">
                  <div class="w-100">
                    <p-accordion>

                      <!-- Description Section -->
                      <p-accordionTab [selected]="true"
                        header="{{ translationData?.serviceDescription || 'Description' }}">
                        <p class="block-brief"></p>
                        <app-text-editor [isReadOnly]="true" [(ngModel)]="model.description"></app-text-editor>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="descriptionAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of descriptionAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>

                      <!-- Prerequisites Section -->
                      <p-accordionTab *ngIf="model?.prerequisites || prerequisitesAttachmentsData?.length"
                        header="{{ translationData?.servicePrerequisites || 'Prerequisites' }}">
                        <app-text-editor [isReadOnly]="true" [(ngModel)]="model.prerequisites"></app-text-editor>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="prerequisitesAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of prerequisitesAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>

                      <!-- Required Documents Section -->
                      <p-accordionTab
                        *ngIf="model?.requiredDocuments || requiredDocumentsAttachmentsData?.length || model?.requiredDocumentsListFormConfig?.length"
                        header="{{ translationData?.serviceRequiredDocuments || 'Required Documents' }}">
                        <app-text-editor [isReadOnly]="true"
                          *ngIf="!model?.requiredDocumentsListFormConfig?.length && model?.requiredDocuments"
                          [(ngModel)]="model.requiredDocuments">
                        </app-text-editor>

                        <ul *ngIf="model?.requiredDocumentsListFormConfig?.length">
                          <li *ngFor="let config of model?.requiredDocumentsListFormConfig">
                            {{ config }}
                          </li>
                        </ul>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="requiredDocumentsAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of requiredDocumentsAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>

                      <!-- Policies & Procedures Section -->
                      <p-accordionTab *ngIf="model?.policiesProcedures || policiesAttachmentsData?.length"
                        header="{{ translationData?.servicePolicesAndProcedures || 'Policies & Procedures' }}">
                        <app-text-editor [isReadOnly]="true" [(ngModel)]="model.policiesProcedures"></app-text-editor>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="policiesAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of policiesAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>

                      <!-- Service Availability Section -->
                      <p-accordionTab *ngIf="hasCustomAvaibailitySection()"
                        header="{{ translationData?.serviceAvailability || 'Service Availability' }}">
                        <app-text-editor *ngIf="!model?.readConfigFees && model?.fees" [isReadOnly]="true"
                          [(ngModel)]="model.fees"></app-text-editor>
                      </p-accordionTab>

                      <!-- Fees Section -->
                      <p-accordionTab
                        *ngIf="(model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)) || model?.fees || feesAttachmentsData?.length"
                        header="{{ translationData?.serviceFees || 'Fees' }}">
                        <app-text-editor *ngIf="!model?.readConfigFees && model?.fees" [isReadOnly]="true"
                          [(ngModel)]="model.fees"></app-text-editor>
                      </p-accordionTab>

                      <!-- Templates Section -->
                      <p-accordionTab *ngIf="templatesAttachmentsData?.length"
                        header="{{ translationData?.templates || 'Templates' }}">
                        <div class="block-content rich-text">{{translationData?.templatesNote || "Any required
                          attachments
                          within the requests should follow the below templates."}}</div>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="templatesAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of templatesAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>
                      <!-- SLA -->
                      <p-accordionTab *ngIf="model?.sla || (model?.readConfigSLA && model?.totalStepsSLA)"
                        header="{{ translationData?.serviceSLA || 'SLA' }}">
                        <app-text-editor *ngIf="!model?.readConfigSLA && model?.sla" [isReadOnly]="true"
                          [(ngModel)]="model.sla"></app-text-editor>

                        <!-- <p class="block-value">3-10 Working Days</p> -->

                        <div *ngIf="model?.readConfigSLA && model?.totalStepsSLA" class="block-content rich-text">
                          {{ translationData?.initialApproval || "Initial Approval" }}
                          <p class="block-value">{{model?.totalStepsSLA + ' ' + (translationData?.workingHours ||
                            'Working
                            Hours')}}</p>
                        </div>

                        <!-- <app-alert-message [hasClose]="false" alertType="message" [active]="true"
                          alertText="{{translationData?.SLANote || 'SLA is depending on the list activities and fulfilling the requirements and this can be subject to change.'}}">
                        </app-alert-message> -->
                      </p-accordionTab>

                      <!-- Terms & Conditions Section -->
                      <p-accordionTab header="{{ translationData?.TermsConditions || 'Terms & Conditions' }}">
                        <app-text-editor [(ngModel)]="model.termsConditions" [isReadOnly]="true"></app-text-editor>

                        <ul class="m-0 uploaded-files-wrapper" *ngIf="termsConditionsAttachmentsData?.length">
                          <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                            *ngFor="let doc of termsConditionsAttachmentsData">
                            <span class="lib-icon-attachement-icon"></span>
                            <span class="uploaded-file-name"
                              title="{{ translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName) }}"
                              (click)="download(doc.attachmentGuid, doc.fileName)">
                              {{ doc.fileName }}
                            </span>
                          </li>
                        </ul>
                      </p-accordionTab>

                    </p-accordion>
                  </div>


                </div>
              </div>
              <!-- <div class="col-lg-9">
                <div class="block-body">

                  <div class="block-section" id="description">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{ translationData?.serviceDescription || "Description" }}
                      <button *ngIf="descriptionAttachmentsData && descriptionAttachmentsData?.length > 1"
                        aria-label="Download All"
                        class="link-btn inner-decoration" (click)="downloadAll(descriptionAttachmentsData)">
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>
                    <p class="block-brief">
                    </p>
                    <app-text-editor [isReadOnly]="true" [(ngModel)]="model.description"></app-text-editor>
                    <ul class="m-0 uploaded-files-wrapper"
                      *ngIf="descriptionAttachmentsData && descriptionAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of descriptionAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="block-section" id="prerequisites"
                    *ngIf="model?.prerequisites || prerequisitesAttachmentsData?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{translationData?.servicePrerequisites || "Prerequisites"}}
                      <button *ngIf="prerequisitesAttachmentsData?.length" class="link-btn inner-decoration"
                        (click)="downloadAll(prerequisitesAttachmentsData)"
                        aria-label="Download All"
                        >
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>

                    <app-text-editor [isReadOnly]="true" [(ngModel)]="model.prerequisites"></app-text-editor>

                    <ul class="m-0 uploaded-files-wrapper" *ngIf="prerequisitesAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of prerequisitesAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="block-section" id="documents"
                    *ngIf="model?.requiredDocuments || requiredDocumentsAttachmentsData?.length || model?.requiredDocumentsListFormConfig?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{translationData?.serviceRequiredDocuments ||"Required Documents"}}
                      <button *ngIf="requiredDocumentsAttachmentsData && requiredDocumentsAttachmentsData?.length > 1"
                        class="link-btn inner-decoration" 
                        aria-label="Download All"
                        (click)="downloadAll(requiredDocumentsAttachmentsData)">
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>

                    <app-text-editor [isReadOnly]="true" *ngIf="!model?.requiredDocumentsListFormConfig?.length && model?.requiredDocuments" [(ngModel)]="model.requiredDocuments"></app-text-editor>

                    <ul *ngIf="model?.requiredDocumentsListFormConfig?.length">
                      <li *ngFor="let config of model?.requiredDocumentsListFormConfig">
                        {{config}}
                      </li>
                    </ul>

                    <ul class="m-0 uploaded-files-wrapper"
                      *ngIf="requiredDocumentsAttachmentsData && requiredDocumentsAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of requiredDocumentsAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>

                  </div>

                  <div *ngIf="model?.sla || (model?.readConfigSLA && model?.totalStepsSLA)" class="block-section"
                    id="sla">

                    <h2 class="block-title">
                      {{ translationData?.serviceSLA || "SLA" }}
                    </h2>

                      <app-text-editor *ngIf="!model?.readConfigSLA && model?.sla" [isReadOnly]="true" [(ngModel)]="model.sla"></app-text-editor>

                      <p class="block-value">3-10 Working Days</p>

                    <div *ngIf="model?.readConfigSLA && model?.totalStepsSLA" class="block-content rich-text">
                       {{ translationData?.initialApproval || "Initial Approval" }}
                      <p class="block-value">{{model?.totalStepsSLA +' '+ (translationData?.workingHours || "Working
                        Hours")}}</p>
                    </div>

                    <app-alert-message [hasClose]="false" alertType="message" [active]="true"
                      alertText="{{translationData?.SLANote ||'SLA is depending on the list activities and fulfilling the requirements and this can be subject to change.'}}">
                    </app-alert-message>

                  </div>

                  <div class="block-section" id="policies"
                    *ngIf="model?.policiesProcedures || policiesAttachmentsData?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{ translationData?.servicePolicesAndProcedures || "Policies & Procedures"}}
                      <button *ngIf="policiesAttachmentsData && policiesAttachmentsData?.length > 1" class="link-btn inner-decoration"
                        (click)="downloadAll(policiesAttachmentsData)"
                        aria-label="Download All"
                        >
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>

                    <app-text-editor [isReadOnly]="true" [(ngModel)]="model.policiesProcedures"></app-text-editor>

                    <ul class="m-0 uploaded-files-wrapper"
                      *ngIf="policiesAttachmentsData && policiesAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of policiesAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>

                  </div>

                  
                  <div class="block-section" id="serviceAvailablility"
                    *ngIf="hasCustomAvaibailitySection()">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{ translationData?.serviceAvailability || "Service Availablility" }}
                    </h2>

                    <ng-container *ngIf="model?.hasCustomApplicantSubmissionFrequency">
                      <div class="font-weight-bold">
                        {{translationData?.applicantRequestingLimit || "Applicant Requesting Limit"}}                   
                      </div>
                      <div class="mb-2" innerHTML="{{
                        translationData?.applicantRequestingLimitMessage
                          ?.replace('{0}', model.maxRequestsPerApplicant)
                          ?.replace('{1}', model.applicantMaxRequestsDurationInDays)
                        }}">
                      </div>
                    </ng-container>
                    <ng-container *ngIf="model?.hasCustomDaysAvailability">
                      <ng-container *ngIf="model.availabilityStartDate || model.availabilityEndDate">
                        <div class="font-weight-bold">
                          {{translationData?.dateRange || "Date Range"}}
                        </div>
                        <div class="mb-2" innerHTML="{{
                          translationData?.serviceAvailabilityDateRange
                            ?.replace('{0}', (!model.availabilityStartDate ? '' : translationData?.fromRange?.replace('{0}', model.availabilityStartDateCalendar)))
                            ?.replace('{1}', (!model.availabilityEndDate ? '' : translationData?.toRange?.replace('{0}', model.availabilityEndDateCalendar)))
                          }}">
                        </div>
                      </ng-container>
                      <div *ngIf="model?.serviceDefinitionAvailabilitySlots?.length" class="font-weight-bold d-flex align-items-center attach-label-holder g-1">
                        <label>
                          {{translationData?.daysAvailability || "Days Availability"}}
                        </label>
                        <label class="info-icon lib-icon-info" *ngIf="configuredTimeZoneStringValue"
                            popover="{{ translationData?.timezoneAddMessage?.replace('{0}', configuredTimeZoneStringValue) || 'Please enter the working hours in GMT time zone' }}"
                            placement="bottom" triggers="click" [outsideClick]="true">
                        </label>
                      </div>
                      <div class="block-content rich-text"
                        *ngIf="model?.serviceDefinitionAvailabilitySlots?.length">
                        <table>
                          <tbody>
                            <tr>
                              <th>{{ translationData?.day || "Day" }}</th>
                              <th>{{ translationData?.startTime || "Start Time" }}</th>
                              <th>{{ translationData?.endTime || "End Time" }}</th>
                              <th>{{ translationData?.maxRequestsPerDay || "Max Requests" }}</th>
                            </tr>
                            <tr *ngFor="let availability of model.serviceDefinitionAvailabilitySlots">
                              <td>{{ availability.dayName }}</td>
                              <td>{{ availability.startTimeDisplay }}</td>
                              <td>{{ availability.endTimeDisplay }}</td>
                              <td>{{ availability.maxRequestsPerDay }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-container>
                  </div>

                   *ngIf="model?.serviceDefinitionFees || feesAttachmentsData?.length"
                  <div class="block-section" id="fees"
                    *ngIf="(model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)) || model?.fees || feesAttachmentsData?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{ translationData?.serviceFees || "Fees" }}
                      <button *ngIf="feesAttachmentsData && feesAttachmentsData?.length > 1" class="link-btn inner-decoration"
                        (click)="downloadAll(feesAttachmentsData)"
                        aria-label="Download All"
                        >
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>

                    <app-text-editor *ngIf="!model?.readConfigFees && model?.fees" [isReadOnly]="true" [(ngModel)]="model.fees"></app-text-editor>

                    <div class="block-content rich-text"
                      *ngIf="model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)">
                      <table>
                        <tbody>
                          <tr>
                            <th>{{ translationData?.feeName || "Fee Name" }}</th>
                            <th>{{ translationData?.feeAmount || "Amount" }}</th>
                          </tr>
                          <tr *ngFor="let fee of model.serviceDefinitionFees">
                            <td>{{ fee.serviceDefinitionFeeLocals[0].name }}</td>
                            <td>
                              {{
                              fee.amount +
                              " " +
                              (currencyTrans[defaultCurrencyValue] || defaultCurrencyValue)
                              }}
                            </td>
                          </tr>
                          <tr class="bottom-row">
                            <td colspan="2">
                              <span>{{
                                translationData?.serviceTotalFees ||
                                "Total Fees:"
                                }}
                              </span>
                              {{
                              getTotalServicFees() +
                              " " +
                              (currencyTrans[defaultCurrencyValue] || defaultCurrencyValue)
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <ul class="m-0 uploaded-files-wrapper" *ngIf="feesAttachmentsData && feesAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of feesAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="block-section" id="templates" *ngIf="templatesAttachmentsData?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{ translationData?.templates || "Templates"}}
                      <button  
                      aria-label="Download All"
                      *ngIf="templatesAttachmentsData && templatesAttachmentsData?.length > 1" class="link-btn inner-decoration"
                        (click)="downloadAll(templatesAttachmentsData)">
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>


                    <div class="block-content rich-text">
                      {{ translationData?.templatesNote || "Any required attachments within the requests should follow
                      the below templates."}}
                    </div>

                    <ul class="m-0 uploaded-files-wrapper"
                      *ngIf="templatesAttachmentsData && templatesAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of templatesAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>

                  </div>

                  <div class="block-section" id="terms"
                    *ngIf="model?.termsConditions || termsConditionsAttachmentsData?.length">
                    <h2 class="block-title d-flex justify-content-between align-items-center">
                      {{translationData?.TermsConditions || "Terms & Conditions"}}
                      <button 
                      aria-label="Download All"
                      *ngIf="termsConditionsAttachmentsData && termsConditionsAttachmentsData?.length > 1"
                        class="link-btn inner-decoration" (click)="downloadAll(termsConditionsAttachmentsData)">
                        <span class="lib-icon-download mx-2"></span>
                        <span class="d-none d-lg-inline">
                          {{translationData?.downloadAll || "Download All"}}
                        </span>
                      </button>
                    </h2>

                    <app-text-editor [(ngModel)]="model.termsConditions" [isReadOnly]="true"></app-text-editor>

                    <ul class="m-0 uploaded-files-wrapper"
                      *ngIf="termsConditionsAttachmentsData && termsConditionsAttachmentsData?.length">
                      <li class="uploaded-file mb-1 p-2 d-flex rounded align-items-center"
                        *ngFor="let doc of termsConditionsAttachmentsData">
                        <span class="lib-icon-attachement-icon"></span>
                        <span class="uploaded-file-name"
                          title="{{translationData?.download?.replace('{0}', doc.fileName) || 'Download {0}'.replace('{0}', doc.fileName)}}"
                          (click)="download(doc.attachmentGuid,doc.fileName)">
                          {{doc.fileName}}
                        </span>
                      </li>
                    </ul>

                  </div>

                </div>
              </div> -->

              <!-- <div class="col-lg-3 d-none d-lg-block">
                <aside class="scrollspy py-4">
                  <ul class="nav-links" (click)="handleNavigation($event)">
                    <li class="active">
                      <a href="description">{{translationData?.serviceDescription || "Description"}}</a>
                    </li>
                    <li *ngIf="model?.prerequisites || prerequisitesAttachmentsData?.length">
                      <a href="prerequisites">{{translationData?.servicePrerequisites || "Prerequisites"}}</a>
                    </li>
                    <li
                      *ngIf="model?.requiredDocuments || requiredDocumentsAttachmentsData?.length || model?.requiredDocumentsListFormConfig?.length">
                      <a href="documents">{{translationData?.serviceRequiredDocuments || "Required Documents"}}</a>
                    </li>
                    <li *ngIf="model?.sla || (model?.readConfigSLA && model?.totalStepsSLA)">
                      <a href="sla">{{ translationData?.serviceSLA || "SLA" }}</a>
                    </li>
                    <li *ngIf="model?.policiesProcedures || policiesAttachmentsData?.length">
                      <a href="policies">{{translationData?.servicePolicesAndProcedures || "Policies & Procedures"}}</a>
                    </li>
                    <li *ngIf="hasCustomAvaibailitySection()">
                      <a href="serviceAvailablility">{{translationData?.serviceAvailability || "Service Availablility"}}</a>
                    </li>
                    <li
                      *ngIf="(model?.readConfigFees && (model?.serviceDefinitionFees || feesAttachmentsData?.length)) || model?.fees|| feesAttachmentsData?.length">
                      <a href="fees">{{translationData?.serviceFees || "Fees"}}</a>
                    </li>
                    <li *ngIf="templatesAttachmentsData?.length">
                      <a href="templates">{{translationData?.templates || "Templates"}}</a>
                    </li>
                    <li>
                      <a href="terms">{{translationData?.TermsConditions || "Terms & Conditions"}}</a>
                    </li>
                  </ul>
                </aside>
              </div> -->
            </div>
          </section>
          <!--
          <section class="service-rating block-wrapper rounded">
            <div class="rating-cont">
                <div class="question">
                    <div class="rating-service">
                        <div class="rating-stars">
                            <ul class="rating event-rating">
                                <li *ngFor="let star of [1,2,3,4,5]" class="star"
                                    [class.filled]="ratingStarId >= star || ratingStarHover>= star"
                                    (mouseover)="ratingStarHover = star"
                                    (click)="ratingStarId = star">
                                    <span class="icon-star"></span>
                                  </li>
                                  <span class="rating-number" *ngIf="ratingStarId||ratingStarHover">{{ratingStarId?ratingStarId:ratingStarHover}}.0</span>
                                  <span class="people-rating-number" *ngIf="totalNumber">
                                    {{totalNumber}} 
                                    {{translationData.Persons || "Persons"}}
                                  </span>
                                </ul>

                        </div>
                        <button type="button" class="btn btn-outline-primary" title="{{translationData.RateService}}"  (click)="submitRating()"> {{translationData.RateService}} </button>
                    </div>      
                </div>
            </div>
          </section>
          -->
        </div>
      </div>
    </div>

  </div>
</ng-container>